import { render, staticRenderFns } from "./searchContainer.vue?vue&type=template&id=a23154f4&scoped=true"
import script from "./searchContainer.vue?vue&type=script&lang=js"
export * from "./searchContainer.vue?vue&type=script&lang=js"
import style0 from "./searchContainer.vue?vue&type=style&index=0&id=a23154f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23154f4",
  null
  
)

export default component.exports